define.alias("checkout/components/add-ons", "calendar/components/add-ons");